// extracted by mini-css-extract-plugin
export default {"hist":"TaskPreview_hist__3Qeka"};